import { gql } from "@apollo/client";

export const GET_PREMIUM_SERVICE_INTERESTS = gql`
  query GetPremiumServiceInterests(
    $page: Int
    $pageSize: Int
    $sort: String
    $search: String
    $searchFields: [String!]
    $status: PremiumServiceInterestStatus
    $region: ID
    $district: ID
    $fromDate: Date
    $toDate: Date
  ) {
    rows: getPremiumServiceInterests(
      page: $page
      pageSize: $pageSize
      sort: $sort
      search: $search
      searchFields: $searchFields
      status: $status
      region: $region
      district: $district
      fromDate: $fromDate
      toDate: $toDate
    ) {
      _id
      code
      region {
        _id
        code
        name
      }
      district {
        _id
        code
        name
      }
      customer {
        fullName
        phoneNumber
        digitalAddress
      }
      status
      appointmentConfirmedAt
      cancelledAt
      createdAt
      updatedAt
    }
    count: getPremiumServiceInterestsCount(
      search: $search
      searchFields: $searchFields
      status: $status
      region: $region
      district: $district
      fromDate: $fromDate
      toDate: $toDate
    )
  }
`;

export const GET_PREMIUM_SERVICE_INTERESTS_SUMMARY = gql`
  query GetPremiumServiceInterestsSummary(
    $search: String
    $searchFields: [String!]
    $sort: String
    $region: ID
    $district: ID
    $fromDate: Date
    $toDate: Date
  ) {
    summary: getPremiumServiceInterestsSummary(
      search: $search
      searchFields: $searchFields
      sort: $sort
      region: $region
      district: $district
      fromDate: $fromDate
      toDate: $toDate
    ) {
      Pending
      AppointmentConfirmed
      Cancelled
    }
  }
`;

const PREMIUM_SERVICE_INTEREST_USER_FIELDS = `
  _id
  code
  lastName
  firstName
  profileImageUrl
  phoneNumber
`;

export const GET_PREMIUM_SERVICE_INTEREST = gql`
  query GetPremiumServiceInterest($id: ID!) {
    premiumServiceInterest: getPremiumServiceInterest(id: $id) {
      _id
      code
      region {
        _id
        code
        name
      }
      district {
        _id
        code
        name
      }
      customer {
        fullName
        phoneNumber
        digitalAddress
      }
      status
      origin
      appointmentConfirmedAt
      appointmentConfirmedBy {
        ${PREMIUM_SERVICE_INTEREST_USER_FIELDS}
      }
      appointment {
        code
        estimatedResolutionDate
        assignee {
          ${PREMIUM_SERVICE_INTEREST_USER_FIELDS}
        }
        status
      }
      cancelledAt
      cancellationReason
      createdBy {
        ${PREMIUM_SERVICE_INTEREST_USER_FIELDS}
      }
      cancelledBy {
        ${PREMIUM_SERVICE_INTEREST_USER_FIELDS}
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PREMIUM_SERVICE_INTEREST = gql`
  mutation CreatePremiumServiceInterest(
    $district: ID
    $customer: PremiumServiceInterestCustomerInput!
    $generateRAT: Boolean
    $ratDetails: PremiumServiceInterestRATDetailsInput
  ) {
    createPremiumServiceInterest(district: $district, customer: $customer, generateRAT: $generateRAT, ratDetails: $ratDetails) {
      _id
    }
  }
`;

export const CANCEL_PREMIUM_SERVICE_INTEREST = gql`
  mutation CancelPremiumServiceInterest($id: ID!, $reason: String!) {
    cancelPremiumServiceInterest(id: $id, reason: $reason) {
      _id
    }
  }
`;

export const CONFIRM_PREMIUM_SERVICE_INTEREST = gql`
  mutation ConfirmPremiumServiceInterest($id: ID!, $assignee: ID!, $estimatedResolutionDate: Date!, $digitalAddress: String!, $priority: RATServiceOrderPriority!, $notes: String!) {
    confirmPremiumServiceInterest(
      id: $id
      assignee: $assignee
      estimatedResolutionDate: $estimatedResolutionDate
      digitalAddress: $digitalAddress
      priority: $priority
      notes: $notes
    ){
      _id
    }
  }
`;
